export default "__VITE_ASSET__Cbtt5UHD__"